import { useSelector } from 'react-redux';
import { useObserver } from './ObserverHooks';
export function useRowSelectedState(isSelected, selectable) {
    if (!isSelected) {
        return undefined;
    }
    const downloadSelectIsActive = selectable !== null &&
        useSelector((state) => state.Storage.DOWNLOAD_SELECT && Object.keys(state.Storage.DOWNLOAD_SELECT).length > 0);
    const selected = !!useObserver({ observer: isSelected });
    return downloadSelectIsActive ? (selected ? 'on' : 'off') : undefined;
}
export function selectedRowCount() {
    return (state) => {
        var _a;
        return Object.keys((_a = state.Storage.DOWNLOAD_SELECT, (_a !== null && _a !== void 0 ? _a : {}))).filter((k) => !k.startsWith('_')).length;
    };
}
